import TaskItem from '../../../../components/list/TaskItem';

function DisplayTable({ list, listLabel, listCheckList, editHandler, idTab }) {

    //const stateSize = useSelector((state) => state.size);
    //const stateUserList = useSelector((state) => state.userList);//Пользователи

    return (
        <>
            {list.map((item) => (
                <TaskItem key={item.ID + '_' + item.ID_User}
                    idObject={6}
                    item={item}
                    editHandler={editHandler}
                    listLabel={listLabel.filter(a => a.ID_Item === item.ID_TaskR)}
                    showCheckList={true}
                    listCheckList={listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID)}
                    showPercent={idTab != 3 ? true : false}
                    showUser={idTab === 2 ? true : false}
                    listUser={[{ ID_User: item.ID_User, ID_Action: item.ID_Action }]}
                    showDateStartEnd={true}
                />
            ))}


            {/*stateSize.windowWidth > 1000 ? (
                list.map((item) => (
                    <div key={item.ID + '_' + item.ID_User} className={"list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                        <div style={{ width: '50%' }}>
                            <div>
                                <div className='title' >{item.Name_Task}{item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                                <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>
                                {/*<DateShow date_start={item.Date_Start} date_complete={item.Date_End} />*//*}
                                {
                                    listLabel.filter(a => a.ID_Item === item.ID_TaskR).map((label) => (
                                        <div key={item.ID_TaskR + '_' + label.ID_Label} className="mr-2 badge_item" style={{ backgroundColor: label.Color, color: "white" }} >
                                            {label.Name}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="center" style={{ width: '300px' }}>
                            {idTab === 2 && (
                                stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 &&
                                <div className="d-flex align-items-center mr-30 mt-5 mb-5">
                                    <div className="mr-5"><AvatarRound img={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small} width={25} name={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User.charAt(0)} /></div>
                                    {stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User}
                                </div>
                            )}
                        </div>
                        <div className="center" style={{ width: '70px' }}>
                            <div>
                                {listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length > 0 &&
                                    (
                                        <>
                                            <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                            <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID & a.Completed == true).length}</b>
                                            /
                                            <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length}</b>
                                        </>
                                    )}
                            </div>
                        </div>
                        <div className="end" style={{ width: '250px' }}>
                            <div>
                                <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{item.Timetable_String === null ? "Вручную" : item.Timetable_String}</div>
                                {<small><DateStartEndForList date_start={item.Date} date_end={item.Date_Finish} /></small>}
                            </div>
                        </div>
                        {idTab != 3 && (
                            <div className="end" style={{ width: '50px' }}>
                                <div style={{ display: "inline-block" }}>
                                    {item.ID_Type === 2 &&
                                        <PercentSuccessV2 percent={Math.round(100 / item.User_All * item.User_Completed)} countAll={item.User_All} countComplete={item.User_Completed} />
                                    }
                                </div>
                            </div>
                        )
                        }
                    </div>
                ))
            ) : (
                list.map((item) => (

                    <div key={item.ID + '_' + item.ID_User} className={"m_list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                        <div>
                            <div className='title' >{item.Name_Task}{item.Viewed === false && <span className="badge badge-menu warning badge-dot ml-5"> </span>}</div>
                            <div className='subtitle'>{item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}</div>
                            {/*<DateShow date_start={item.Date_Start} date_complete={item.Date_End} />*//*}
                            {
                                listLabel.filter(a => a.ID_Item === item.ID_TaskR).map((label) => (
                                    <div key={item.ID_TaskR + '_' + label.ID_Label} className="mr-2 badge_item" style={{ backgroundColor: label.Color, color: "white" }} >
                                        {label.Name}
                                    </div>
                                ))
                            }
                        </div>
                        <div className='mt-5'>
                            <i className="mr-10"><FontAwesomeIcon icon={faClock} /></i>{item.Timetable_String === null ? "Вручную" : item.Timetable_String}
                            <DateStartEndForList date_start={item.Date} date_end={item.Date_Finish} />
                        </div>
                        <div className='mt-5'>
                            {listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length > 0 &&
                                (
                                    <>
                                        <FontAwesomeIcon icon={faSquareCheck} className="mr-5" />
                                        <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID & a.Completed == true).length}</b>
                                        /
                                        <b>{listCheckList.filter(a => a.ID_TaskR_Tracker === item.ID).length}</b>
                                    </>
                                )}
                        </div>
                        <div className="mt-5">
                            {idTab === 2 && (
                                stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 &&
                                <div className="d-flex align-items-center mr-30 mt-5 mb-5">
                                    <div className="mr-5"><AvatarRound img={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small} width={25} name={stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User.charAt(0)} /></div>
                                    {stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User}
                                </div>
                            )}
                        </div>
                        {idTab != 3 && (
                            <div className="mt-5">
                                {
                                    item.ID_Type === 2 &&
                                    <PercentSuccessV2 percent={Math.round(100 / item.User_All * item.User_Completed)} />
                                }
                            </div>
                        )
                        }
                    </div>
                ))

            )*/}

        </>)
}

export default DisplayTable;